import { ContextData } from './getOnboardingContext'

// Tink AIS session (XS2A.risk): only account access is requested, no 0,01 EUR
// transfer. A missing transactionType means an older backend and therefore a
// micropayment.
export function isAccountInformation(context?: ContextData): boolean {
  return context?.transactionType === 'AccountInformation'
}
